@if (isLoadedInitialData) {
  <app-side-panel
    #sidePanel
    [table]="TABLES.TRACK"
    [printOptionActions]="sidePanelPrintActions"
    [showFraud]="false"
    [trackTable]="true"
    (onSyncOrder)="reSyncOrderClick($event, true)"
    (changeColorCoding)="changeColorCoding($event)"
    (changeColorCodingDisplay)="changeColorCodingDisplay($event)">
  </app-side-panel>
  <mat-drawer-container class="track-screen">
    <mat-drawer-content>
      <div [ngClass]="loading ? 'disabledbtn' : ''">
        <div class="track-screen__title">{{ screenTitle }}</div>
        <div class="track-screen__tabs">
          <pdq-tabs-group (onChange)="onFilterChange($event)">
            <pdq-tab
              [value]="FilterTypes.ALL_STATUSES"
              [label]="
                useCursorPagination()
                  ? cappedAllLabel()
                  : getLabelAndCounterString(FilterTypes.LABEL_ALL, countAllStatus)
              "
              [loading]="useCursorPagination() && deliverCursorPagination.tabCountersLoading()"></pdq-tab>
            <pdq-tab
              [value]="FilterTypes.PRE_TRANSIT"
              [label]="
                useCursorPagination()
                  ? cappedPreTransitLabel()
                  : getLabelAndCounterString(FilterTypes.LABEL_PRE_TRANSIT, countPreTransitStatus)
              "
              [loading]="useCursorPagination() && deliverCursorPagination.tabCountersLoading()"></pdq-tab>
            <pdq-tab
              [value]="FilterTypes.IN_TRANSIT"
              [label]="
                useCursorPagination()
                  ? cappedInTransitLabel()
                  : getLabelAndCounterString(FilterTypes.LABEL_IN_TRANSIT, countInTransitStatus)
              "
              [loading]="useCursorPagination() && deliverCursorPagination.tabCountersLoading()"></pdq-tab>
            <pdq-tab
              [value]="FilterTypes.DELIVERED"
              [label]="
                useCursorPagination()
                  ? cappedDeliveredLabel()
                  : getLabelAndCounterString(FilterTypes.LABEL_DELIVERED, countDeliveredStatus)
              "
              [loading]="useCursorPagination() && deliverCursorPagination.tabCountersLoading()"></pdq-tab>
            <pdq-tab
              [value]="FilterTypes.FLAGGED"
              [label]="
                useCursorPagination()
                  ? cappedFlaggedLabel()
                  : getLabelAndCounterString(FilterTypes.LABEL_FLAGGED, countFlaggedStatus)
              "
              [loading]="useCursorPagination() && deliverCursorPagination.tabCountersLoading()"></pdq-tab>
            <pdq-tab
              [value]="FilterTypes.RETURNS"
              [label]="
                useCursorPagination()
                  ? cappedReturnsLabel()
                  : getLabelAndCounterString(FilterTypes.RETURNS, returnsCount)
              "
              [loading]="useCursorPagination() && deliverCursorPagination.tabCountersLoading()"></pdq-tab>
            <pdq-tab
              [value]="FilterTypes.RESHIPS"
              [label]="
                useCursorPagination()
                  ? cappedReshipLabel()
                  : getLabelAndCounterString(FilterTypes.RESHIPS, reshipsCount)
              "
              [loading]="useCursorPagination() && deliverCursorPagination.tabCountersLoading()"></pdq-tab>
          </pdq-tabs-group>
        </div>
        <div class="track-screen__tabs-lower">
          <div class="track-screen__columns">
            <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook  -->
            <mat-select
              class="table-columns-select"
              panelClass="pdq-mat-select--panel__multi"
              [(ngModel)]="selectedColumns"
              (selectionChange)="toggleColumn()"
              [disableOptionCentering]="true"
              multiple
              matTooltipClass="pdq-mat-tooltip"
              [matTooltip]="'Edit columns'">
              <div class="pdq-mat-select--panel--header">
                Showing {{ selectedColumns.length + '/' + COLUMN_OPTIONS.length }} columns
              </div>
              @for (column of COLUMN_OPTIONS; track column) {
                <mat-option selected="selected" [value]="column.prop">
                  {{ column.name }}
                </mat-option>
              }
            </mat-select>
          </div>
          <div class="track-screen__free-search">
            <app-newui-search-autocomplete
              (searchResultsToTable)="onSearchToTable($event)"
              [table]="TABLES.TRACK"
              [showDeletedOrders]="false"></app-newui-search-autocomplete>
          </div>
        </div>
        <div class="track-table-container">
          <app-table
            [table]="TABLES.TRACK"
            [rows]="temp"
            [columnsSettings]="columns"
            [rowsLoading]="loading"
            [selected]="selectedOrders"
            [rowActions]="rowActions"
            [groupActions]="groupActions"
            [printOptionActions]="tablePrintActions"
            [perPageActiveOption]="ordersPerPage"
            [totalCountOrders]="totalCountOrders"
            [allPages]="allPages"
            [activePage]="activePage"
            [focusedRowId]="focusedOrderId"
            [totalPages]="totalPages"
            [trackTable]="true"
            [isSyncingOrders]="isSyncingGroupOrders"
            [message]="chooseEmptyMessage()"
            (sort)="sortColumns($event)"
            (changeFilter)="onChangeTableFilter($event)"
            (changePerPage)="onChangeOrdersPerPage($event)"
            (changePage)="paginate($event)"
            (jumpToPage)="jumpToPage($event)"
            (returnOrderToAssign)="backToAssignSingleOrder($event)"
            (deleteOrder)="onDeleteOrder($event)"
            (getStatus)="updateOrderTrackingStatus($event)"
            (changeSelectedOrders)="onChangeSelectedOrders($event)"
            (returnSelectedOrderToAssign)="backToAssignSelectedOrders()"
            (reSyncSelectedOrder)="reSyncSelectedOrder()"
            (onTableActivate)="onTableActivate($event)"
            (exportSelectedOrders)="exportSelectedOrders($event)"
            (deleteSelectedOrder)="deleteSelectedOrder()"
            (onBulkPrint)="onBulkPrint($event)"
            (onBulkColorCodingApply)="bulkChangeColorCoding($event)"
            (updateOrderToDelivered)="updateOrderToDeliveredStatus($event)"
            (changeColorCoding)="changeColorCoding($event)"
            [paginationMode]="useCursorPagination() ? 'cursor' : 'offset'"
            [cursorRangeLabel]="deliverCursorPagination.rangeLabel()"
            [cursorHasNextPage]="deliverCursorPagination.hasNextPage()"
            [cursorHasPreviousPage]="deliverCursorPagination.hasPreviousPage()"
            [totalCountDisplay]="useCursorPagination() ? deliverCursorPagination.totalCountDisplay() : null"
            (cursorPageChange)="onCursorPageChange($event)"></app-table>
        </div>
      </div>
    </mat-drawer-content>
  </mat-drawer-container>
} @else {
  <skeleton-workspace-page [titleText]="screenTitle"></skeleton-workspace-page>
}
